// Data for The Fussed Bulb landing page
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const servicesData = [
  {
    id: 1,
    title: "Brand Strategy",
    description: "Positioning, differentiation, narrative architecture.",
  },
  {
    id: 2,
    title: "Messaging Systems",
    description: "Clear value communication across touchpoints.",
  },
  {
    id: 3,
    title: "Creative Execution",
    description: "Identity systems and strategic design rollouts.",
  },
];

export const processSteps = [
  {
    number: "01",
    title: "Discover",
    description: "We understand your business beyond surface metrics.",
  },
  {
    number: "02",
    title: "Define",
    description: "We articulate your strategic position.",
  },
  {
    number: "03",
    title: "Design",
    description: "We build assets aligned to that clarity.",
  },
  {
    number: "04",
    title: "Deploy",
    description: "We support execution and refinement.",
  },
];

export const proofMetrics = [
  "Clarified positioning \u2192 2\u00d7 conversion improvement",
  "Messaging overhaul \u2192 higher quality inbound",
  "Brand realignment \u2192 consistent growth narrative",
];

// Contact form submission - saves to backend
export const submitContactForm = async (data) => {
  const response = await axios.post(`${API}/contact`, data);
  return { success: true, data: response.data };
};
